var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1163 7.20276H6.87988V5.08017C6.87988 4.28303 7.40819 4.09719 7.7803 4.09719C8.15157 4.09719 10.0642 4.09719 10.0642 4.09719V0.592843L6.91882 0.580566C3.42717 0.580566 2.63258 3.19422 2.63258 4.86681V7.20276H0.613281V10.8138H2.63258C2.63258 15.448 2.63258 21.0318 2.63258 21.0318H6.87988C6.87988 21.0318 6.87988 15.393 6.87988 10.8138H9.74584L10.1163 7.20276Z",
    fill: "#B343D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.494dffb08d324d61053fc6d242e30429.svg";
export { ForwardRef as ReactComponent };